import { useQuery } from 'react-query';
import { AxiosError } from 'axios';
import { Axios } from '@utils/api/axios-instance';
import { URL_EXTENSION } from '@utils/constants/app-constants';
import { BaseError } from '@utils/types/shared/base';
import { SettingsOverview } from '@utils/types/back-office/settings';

export const SETTINGS_OVERVIEW_QUERY_KEY = 'settings-overview';

/**
 * Hook to fetch settings overview statistics
 *
 * GET /api/admin/settings/overview
 *
 * Returns counts: total_languages, total_stt_configs, total_feature_flags, total_system_defaults
 */
export const useGetSettingsOverview = () => {
  const fetchOverview = async (): Promise<SettingsOverview> => {
    const response = await Axios.get<SettingsOverview>(
      `${URL_EXTENSION}/admin/settings/overview`
    );
    return response.data;
  };

  return useQuery<SettingsOverview, AxiosError<BaseError>>(
    [SETTINGS_OVERVIEW_QUERY_KEY],
    fetchOverview,
    {
      staleTime: 60000, // 1 minute
      refetchOnWindowFocus: false
    }
  );
};
